import { fromJS } from 'immutable';
import { LoaderStatus } from '../common/components/CommonLoader';

const initialData = fromJS({
  items: [],
  totalItems: 0,
  loaderStatus: LoaderStatus.IN_PROGRESS,
});

export const SEARCH_LOCATIONS = 'SEARCH_LOCATIONS';
export const SEARCH_LOCATIONS_SUCCESS = 'SEARCH_LOCATIONS_SUCCESS';
export const SEARCH_LOCATIONS_FAILURE = 'SEARCH_LOCATIONS_FAILURE';

export default (state = initialData, { type, payload }) => {
  switch (type) {
    case SEARCH_LOCATIONS:
      return state.merge({
        loaderStatus: LoaderStatus.IN_PROGRESS,
      });
    case SEARCH_LOCATIONS_SUCCESS: {
      return state.merge({
        items: payload.data.content,
        totalItems: payload.data.totalItems,
        loaderStatus: LoaderStatus.SUCCESS,
      });
    }
    case SEARCH_LOCATIONS_FAILURE:
      return state.merge({
        loaderStatus: LoaderStatus.NOT_PENDING,
      });
    default:
      return state;
  }
};
